module.exports = __webpack_public_path__ + "static/media/SarahSwitek_01_Introduction_5.e2fd7831.mp3";